export var switchDefaultTheme = {
  Toggle: {
    base: {
      backgroundColor: '$color.neutral.00'
    },
    disabled__checked: {
      backgroundColor: '$color.neutral.02'
    }
  },
  Label: {
    base: {
      backgroundColor: '$color.neutral.05'
    },
    disabled: {
      backgroundColor: '$color.neutral.03'
    },
    checked: {
      backgroundColor: '$color.primary.main'
    },
    hover: {
      backgroundColor: '$color.primary.light'
    },
    disabled__checked: {
      backgroundColor: '$color.primary.lightest'
    }
  }
};